/* eslint-disable array-element-newline */

export const BNPL_COUNTRIES = [
    'HUN', 'POL', 'SVK', 'CZE', 'DEU', 'ROU', 'ITA', 'AUT', 'FRA', 'NLD',
    'BEL', 'ESP', 'DNK', 'SWE', 'PRT', 'LTU', 'EST', 'LVA', 'BGR', 'SVN',
    'CHE', 'GBR', 'IRL', 'FIN', 'GRC', 'HRV', 'LUX', 'MLT', 'CYP',
];

/* eslint-enable */

export const VAT_COUNTRIES = [ 'DEU' ];